<ng-container *ngIf="priceLists$ | async as priceLists">
  <ng-container *ngIf="data$ | async as data">
    <mat-table #table [dataSource]="dataSource" *ngIf="!data.error" class="w-full elastic-model-list-table">
      <ng-container matColumnDef="select">
        <mat-header-cell *matHeaderCellDef class="max-w-16"
          ><mat-checkbox
            [ngModel]="selectedAll"
            (change)="selectAll()"
            [disabled]="dataSource.data.length === 0 || !editableOrder"></mat-checkbox
        ></mat-header-cell>
        <mat-cell *matCellDef="let item" class="max-w-16"
          ><mat-checkbox
            [disabled]="!editableOrder"
            (click)="$event.stopPropagation()"
            (change)="$event ? selectedProducts.toggle(item.id) : null"
            [checked]="selectedProducts.isSelected(item.id)"></mat-checkbox
        ></mat-cell>
      </ng-container>

      <!-- Preview Column -->
      <ng-container matColumnDef="preview">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let item">
          <div class="preview-wrapper h-full w-full flex flex-col justify-center">
            <img
              class="preview"
              src="{{ getProductImagePath(item.id) }}"
              onerror="this.onerror=null; this.src='/assets/images/no-image.svg'" />
          </div>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef i18n>Название</mat-header-cell>
        <mat-cell *matCellDef="let item">{{ item.name }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="article">
        <mat-header-cell *matHeaderCellDef i18n class="max-w-20">Артикул</mat-header-cell>
        <mat-cell *matCellDef="let item" class="max-w-20">{{ item.article }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="loadingState">
        <mat-header-cell *matHeaderCellDef i18n>Статус</mat-header-cell>
        <mat-cell *matCellDef="let item">
          <ng-container [ngSwitch]="item.loadingState">
            <div i18n *ngSwitchCase="0">Добавление</div>
            <div i18n *ngSwitchCase="1">Ожидает сопоставления материалов</div>
            <div i18n *ngSwitchCase="2">Материалы сопоставлены</div>
            <div i18n *ngSwitchCase="3">Изделие добавлено</div>
            <div i18n *ngSwitchCase="4">Изделие успешно обработано</div>
            <div i18n *ngSwitchCase="5">Ошибка</div>
          </ng-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="materials">
        <mat-header-cell *matHeaderCellDef class="max-w-36" i18n>Материалы</mat-header-cell>
        <mat-cell *matCellDef="let item" class="max-w-36">
          <ng-container [ngSwitch]="item.loadingState">
            <div *ngSwitchCase="0">
              <div class="flex flex-row gap-2 items-center">
                <mat-spinner [diameter]="16"></mat-spinner>
                <div i18n>Создание модели</div>
              </div>
            </div>
            <div *ngSwitchCase="1">
              <button mat-raised-button color="accent" i18n (click)="openLinkProductMaterials([item])"
                >Сопоставить</button
              >
            </div>
            <div *ngSwitchCase="2">
              <div class="flex flex-row gap-2 items-center">
                <mat-spinner [diameter]="16"></mat-spinner>
                <div i18n>Замена материалов</div>
              </div>
            </div>
            <div *ngSwitchCase="3">
              <button mat-raised-button color="accent" i18n (click)="openElasticModelElementsInfoDialog(item)"
                >Материалы</button
              >
            </div>
            <div *ngSwitchCase="4">
              <button mat-raised-button color="accent" i18n (click)="openElasticModelElementsInfoDialog(item)"
                >Материалы</button
              >
            </div>
            <div i18n *ngSwitchCase="5">Ошибка</div>
          </ng-container>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="sign">
        <mat-header-cell *matHeaderCellDef class="max-w-24" i18n>Обозначение</mat-header-cell>
        <mat-cell *matCellDef="let item" class="max-w-24">{{ item.sign }}</mat-cell>
      </ng-container>

      <ng-container matColumnDef="size">
        <mat-header-cell *matHeaderCellDef class="max-w-40" i18n>Габариты (ВШГ)</mat-header-cell>
        <mat-cell *matCellDef="let item" class="max-w-40">
          {{ item.height }}&times;{{ item.width }}&times;{{ item.deep }} <span i18n>мм</span>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="count">
        <mat-header-cell *matHeaderCellDef class="max-w-24" i18n>Количество</mat-header-cell>
        <mat-cell *matCellDef="let item" class="max-w-24">{{ item.count }}</mat-cell>
      </ng-container>

      <!-- Price Column -->
      <ng-container matColumnDef="price">
        <mat-header-cell *matHeaderCellDef class="max-w-32" i18n>Стоимость</mat-header-cell>
        <mat-cell *matCellDef="let item" class="max-w-32">
          <span *ngIf="item.processingMode === 0">{{
            item.price * item.count | formatNumber : 2 | formatCurrency
          }}</span>
        </mat-cell>
      </ng-container>

      <!-- Edit Column -->
      <ng-container matColumnDef="edit">
        <mat-header-cell *matHeaderCellDef></mat-header-cell>
        <mat-cell *matCellDef="let item">
          <button mat-icon-button (click)="openEditProductDialog(item)">
            <mat-icon>edit</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <!-- View Column -->
      <ng-container matColumnDef="view">
        <mat-header-cell *matHeaderCellDef class="max-w-16" i18n></mat-header-cell>
        <mat-cell *matCellDef="let item" class="max-w-16">
          <button mat-icon-button (click)="showProductModel(item)" i18n-matTooltip matTooltip="Открыть 3D модель">
            <mat-icon>3d_rotation</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="delete">
        <mat-header-cell class="max-w-16" *matHeaderCellDef>
          <button mat-icon-button [matMenuTriggerFor]="delete"><mat-icon>more_vert</mat-icon></button
          ><mat-menu #delete="matMenu">
            <button
              mat-menu-item
              i18n
              [disabled]="!editableOrder || dataSource.data.length === 0"
              (click)="deleteCuttingProducts()"
              >Удалить выбранные изделия</button
            >
          </mat-menu>
        </mat-header-cell>
        <mat-cell class="max-w-16" *matCellDef="let item">
          <button [disabled]="!editableOrder" mat-icon-button (click)="deleteCuttingProduct(item)">
            <mat-icon>delete</mat-icon>
          </button>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedColumns"></mat-row>
    </mat-table>

    <div *ngIf="!data.error && !data.result">Loading…</div>

    <div *ngIf="data.error">
      <ng-container *ngIf="+data.error.status === 400; else elseErrorTemplate">
        <div class="p-4" i18n>Прайс-лист не загружен</div>
      </ng-container>
      <ng-template #elseErrorTemplate>
        {{ data.error | json }}
      </ng-template>
    </div>
  </ng-container>

  <div *ngIf="!priceLists.error && !priceLists.result">Loading…</div>

  <div *ngIf="priceLists.error">
    {{ priceLists.error | json }}
  </div>
</ng-container>
